(() => {
  const hero = document.querySelector('.bs-collection-visual-hero');
  if (!hero) return;

  const nav = document.querySelector('.bs-nav');
  if (!nav || nav.dataset.bsCollectionHeroBound === '1') return;

  nav.dataset.bsCollectionHeroBound = '1';
  let ticking = false;

  const update = () => {
    ticking = false;
    const headerHeight = nav.getBoundingClientRect().height +
      (document.querySelector('.bs-announcement-bar')?.getBoundingClientRect().height || 0);
    const heroEnd = hero.getBoundingClientRect().bottom + window.scrollY;
    nav.classList.toggle('is-transparent', window.scrollY <= Math.max(0, Math.min(300, heroEnd - headerHeight)));
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const updateLayout = () => {
    // Use the hero's real flow position so announcement + navigation remain inside its square.
    const marginTop = Number.parseFloat(getComputedStyle(hero).marginTop) || 0;
    const flowTop = hero.getBoundingClientRect().top + window.scrollY - marginTop;
    hero.style.setProperty('--bs-collection-header-offset', `${Math.max(0, flowTop)}px`);
    update();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', updateLayout);
  window.addEventListener('resize', updateLayout);
  updateLayout();
  requestAnimationFrame(updateLayout);
  document.fonts?.ready.then(updateLayout);
})();
